import {UPDATE_NATURE_MAGAZINE_ERROR, UPDATE_NATURE_MAGAZINE_START, UPDATE_NATURE_MAGAZINE_SUCCESS} from "../../types";

export default function update_nature_magazine(state, action) {
    switch (action.type) {
        case UPDATE_NATURE_MAGAZINE_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_NATURE_MAGAZINE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case UPDATE_NATURE_MAGAZINE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
